<template>
  <div class="pa-2">
    <layout-sub-modulo>
      <template #title>Empleados retirados </template>
      <template #body>
        <filtrar-empleados-retirados>
          <template #empresa>
            <v-autocomplete
              v-model="filtros.empresa"
              :items="listaEmpresas"
              label="Empresa"
              item-text="text"
              item-value="value"
              dense
              outlined
              clearable
              @change="filtros.sucursal = null"
              hide-details
            />
          </template>
          <template #sucursal>
            <v-autocomplete
              v-model="filtros.sucursal"
              :items="listaSucursales"
              label="Sucursal"
              item-text="text"
              item-value="value"
              :disabled="!filtros.empresa"
              dense
              outlined
              clearable
              hide-details
            />
          </template>
        </filtrar-empleados-retirados>

        <table-empleados-retirados :empleadosRetirados="informacionTabla">
          <template #botones>
            <v-btn
              class="px-2 mr-1 text-white text-capitalize"
              color="primary"
              dark
              :loading="empleadosRetirados.loading"
              :disabled="empleadosRetirados.loading"
              @click="descargarExcel"
            >
              Descargar Excel
            </v-btn>
          </template>
        </table-empleados-retirados>
      </template>
    </layout-sub-modulo>
  </div>
</template>

<script>
import moment from 'moment';

import empleadoService from '../../../Services/empleadoService.js';
import TableEmpleadosRetirados from './Table/EmpleadosRetiradosTable.vue';
import LayoutSubModulo from '../../../components/Layout/SubModulo.vue';
import FiltrarEmpleadosRetirados from './Form/FiltrarEmpleadosRetirados.vue';
import { descargarHistoricoEmpleadosRetirados } from './reports/descargarHistoricoEmpRetirados.js';

export default {
  name: 'EmpleadosRetirados',

  components: {
    TableEmpleadosRetirados,
    LayoutSubModulo,
    FiltrarEmpleadosRetirados,
  },

  data() {
    return {
      empleadosRetirados: {
        data: [],
        loading: false,
      },
      filtros: {
        empresa: null,
        sucursal: null,
      },
    };
  },

  computed: {
    empleadosFiltrados() {
      const { empresa, sucursal } = this.filtros;
      const dataRaw = this.empleadosRetirados.data;

      if (!empresa && !sucursal) return dataRaw;

      return dataRaw.filter(empleado => {
        const coincideEmpresa = !empresa || empleado.NitCompañia === empresa;
        const coincideSucursal = !sucursal || empleado.IdSucursal === sucursal;
        return coincideEmpresa && coincideSucursal;
      });
    },

    informacionTabla() {
      return {
        loading: this.empleadosRetirados.loading,
        data: this.empleadosFiltrados,
      };
    },

    listaEmpresas() {
      const maps = new Map();
      this.empleadosRetirados.data.forEach(empleado => {
        if (!maps.has(empleado.NitCompañia)) {
          maps.set(empleado.NitCompañia, empleado.DescCompañia);
        }
      });
      return Array.from(maps, ([value, text]) => ({ value, text }));
    },

    listaSucursales() {
      if (!this.filtros.empresa) return [];
      const maps = new Map();

      this.empleadosRetirados.data.forEach(empleado => {
        if (
          empleado.NitCompañia === this.filtros.empresa &&
          !maps.has(empleado.IdSucursal)
        ) {
          maps.set(empleado.IdSucursal, empleado.DescripcionSucursal);
        }
      });
      return Array.from(maps, ([value, text]) => ({ value, text }));
    },
  },

  created() {
    this.listarEmpleadosRetirados();
  },

  methods: {
    async listarEmpleadosRetirados() {
      this.empleadosRetirados.loading = true;
      const filtro = { estaRetirado: true };
      const response = await empleadoService.buscarTodos(filtro);

      const datosTransformados = response.data.map(this.mapearDatosEmpleado);

      this.empleadosRetirados.data = datosTransformados;
      this.empleadosRetirados.loading = false;
    },

    mapearDatosEmpleado(empleado) {
      return {
        ...empleado,
        identificacion: `${empleado.TipoDocumento} - ${empleado.NumeroDocumento}`,
        tipoContrato: empleado.TipoContrato.DescTipoContrato,
        fechaIngresoFormateada: this.formatearFecha(empleado.FechaIngreso),
        fechaContratoHastaFormateada: this.formatearFecha(
          empleado.FechaContratoHasta
        ),
      };
    },

    formatearFecha(fecha) {
      if (!fecha) return '--';
      return moment(fecha).format('DD/MM/YYYY');
    },

    async descargarExcel() {
      try {
        const datos = {
          fileName: 'Historico_Empleados_Retirados',
          empleadosRetirados: this.empleadosFiltrados,
        };

        await descargarHistoricoEmpleadosRetirados(datos);
      } catch (error) {
        console.error('Error al descargar el Excel:', error);
      }
    },
  },
};
</script>
